<template>
    <div class="vacation-country-select">
        <vacation-type-swiper class="vacation-country-slider">
            <div class="swiper-slide" :data-term="country.term_id" v-for="country in countries">
                <div class="slide-inner-wrap">
                    <div @click="nextStep()" :style="{ 'background-image': 'url(' + country.thumbnail + ')' }" class="slide-inner">
                        <div class="slide-fade"></div>
                        <div class="slide-inside">
                            <div class="title country">{{country.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </vacation-type-swiper>
        <next-step-btn></next-step-btn>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VacationTypeSwiper from './VacationTypeSwiper.vue';
    import VacationPlanSlider from '../../components/VacationPlanSlider';
    import NextStepBtn from './NextStepBtn.vue';

    export default {
        components: {
            VacationTypeSwiper, NextStepBtn
        },
        props: ['countries'],
        data() {
            return {
                siteData: window.siteData
            }
        },
        created() {
            this.$parent.selected_filters.country_term = this.countries[0].term_id;
        },
        methods: {
            nextStep() {
                window.eventBus.$emit('nextStep');
            }
        },
        mounted() {
            let $slider = new VacationPlanSlider('.vacation-country-slider');

            Vue.nextTick(() => {
                $slider.swiper.on('slideChange', function () {
                    const countryTerm = $($slider.swiper.slides[$slider.swiper.activeIndex]).data('term');
                    window.eventBus.$emit('selectCountry', countryTerm);
                });
            });
        }
    }
</script>
